import React, { useContext } from 'react';
import { Box, Wrapper } from '@honda-canada/design-system-react';

import BottomElementContext from '../service/BottomElementProvider/BottomElementContext';
import FooterContext from '../service/FooterContext';
import MenuBottom from './MenuBottom';
import MenuMain from './MenuMain';
import MenuSecondary from './MenuSecondary';
import MenuTop from './MenuTop';
import themeStyles from '../Footer.styles';

const DesktopWrapper = themeStyles.apply(Box, 'DesktopWrapper');
const Container = themeStyles.apply(Wrapper, 'Container');

const DesktopFooter = () => {
  const { footerWidthPx, footerPaddingTop } = useContext(FooterContext);
  const { isHidden } = useContext(BottomElementContext);

  return (
    <DesktopWrapper paddingTop={footerPaddingTop} data-testid="cy-footer-desktop" isHidden={isHidden}>
      <Container $maxWidth={footerWidthPx}>
        <MenuTop />
        <MenuMain />
        <MenuSecondary />
        <MenuBottom />
      </Container>
    </DesktopWrapper>
  );
};

export default DesktopFooter;
